
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/parking/booking/new/details",
      function () {
        return require("private-next-pages/[locale]/parking/booking/new/details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/parking/booking/new/details"])
      });
    }
  